// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vF-m","colBig":"styles_colBig__34y6i","colSmall":"styles_colSmall__26u_H","shopifyNameWrapper":"styles_shopifyNameWrapper__1x-bE"};